import { render, staticRenderFns } from "./TextAnimation.vue?vue&type=template&id=05c11106&scoped=true&"
import script from "./TextAnimation.vue?vue&type=script&lang=js&"
export * from "./TextAnimation.vue?vue&type=script&lang=js&"
import style0 from "./TextAnimation.vue?vue&type=style&index=0&id=05c11106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c11106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c11106')) {
      api.createRecord('05c11106', component.options)
    } else {
      api.reload('05c11106', component.options)
    }
    module.hot.accept("./TextAnimation.vue?vue&type=template&id=05c11106&scoped=true&", function () {
      api.rerender('05c11106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/TextAnimation.vue"
export default component.exports